import { Button, DatePicker } from "antd";
import { useDocsOfUser } from "../../../statistics/hooks/use-doc-of-user";
import { ColumnsType } from "antd/lib/table";
import { getDDMMYYYFormat } from "../../../../helper/dateTimeHelper";
import { FontFa, Table } from "../../../../components";
import "./index.scss";
import { useUser } from "../../../../hook";
import moment, { Moment } from "moment";
import { useSearchParams } from "../../../../hook/use-search-params";
import { downloadExcel } from "react-export-table-to-excel";
import { UserDocsType } from "../../../../services/department-viags/statistics-employee.service";
import { TableHelpers } from "../../../../helper/TableHelper";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";

export const UserDocumentTable = () => {
  const {
    filteredData: docsOfUserData,
    isLoading,
    countReadDocument,
    countUnReadDocument,
    countTotalDocument,
  } = useDocsOfUser();
  const { name } = useUser();
  const { pushSearchParams, searchParams } = useSearchParams();
  var history = useHistory();

  const goToDetail = (docId: string, id: string) => {
    const filterQuery = `?status=publish&fileId=${id}&action=info&index="1"`;
    history.push(Routes.documentDetail.path.replace(":id", `${docId}${filterQuery}`));
  };

  const handleExport = () => {
    let result: any = docsOfUserData?.map((dou: UserDocsType) => {
      return {
        ...dou,
        publishDay: getDDMMYYYFormat(dou.publishDay),
        effectiveDate: getDDMMYYYFormat(dou.effectiveDate),
        seen: dou.seen ? "✔" : "",
        unseen: dou.seen ? "" : "❌",
      };
    });

    const exportContent: {
      fileName: string;
      sheet?: string;
      content: Array<{ header: string; dataIndex: string }>;
    } = {
      fileName: "ThongKeTaiLieu_" + name,
      content: [
        { header: "Mã tài liệu", dataIndex: "docCode" },
        { header: "Tên tài liệu", dataIndex: "docName" },
        { header: "Loại tài liệu", dataIndex: "docType" },
        { header: "Tình Trạng", dataIndex: "docStatus" },
        { header: "Ngày ban hành	", dataIndex: "publishDay" },
        { header: "Ngày hết hiệu lực	", dataIndex: "effectiveDate" },
        { header: "Đã đọc", dataIndex: "seen" },
        { header: "Chưa đọc", dataIndex: "unseen" },
      ],
    };

    const body = result.map((e: any) => {
      let obj: any = {};
      exportContent.content
        .map((e) => e.dataIndex)
        .forEach((key, i) => {
          obj[i] = e[key];
        });
      return obj;
    });

    downloadExcel({
      fileName: exportContent.fileName,
      sheet: exportContent?.sheet || "Sheet 1",
      tablePayload: {
        header: exportContent.content.map((e) => e.header),
        body,
      },
    });
  };

  console.log(docsOfUserData);

  const columns: ColumnsType<any> = [
    {
      title: "Mã tài liệu",
      dataIndex: "docCode",
      key: "docCode",
      align: "center" as const,
      width: 120,
      ...TableHelpers.searchInput({ dataIndex: "docCode" }),
    },
    {
      title: "Tên tài liệu",
      dataIndex: "docName",
      key: "docName",
      ...TableHelpers.searchInput({ dataIndex: "docName" }),
      render: (value, record: any) => <Button type="link" onClick={() => goToDetail(record.docId, record.id)}>{value}</Button>,
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      key: "docType",
      filters: [
        {
          text: "Nội bộ",
          value: "Nội bộ",
        },
        {
          text: "Bên ngoài",
          value: "Bên ngoài",
        },
      ],
      onFilter: (status: any, record) => record.docType.indexOf(status) === 0,
    },
    {
      title: "Tình Trạng",
      dataIndex: "docStatus",
      key: "docStatus",
    },
    {
      title: "Ngày ban hành",
      dataIndex: "publishDay",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "publishDay",
      ...TableHelpers.searchRangePicker({ dataIndex: "publishDay" }),
    },
    {
      title: "Ngày hết hiệu lực",
      dataIndex: "effectiveDate",
      render: (date: string) => getDDMMYYYFormat(date),
      key: "effectiveDate",
      ...TableHelpers.searchRangePicker({ dataIndex: "effectiveDate" }),
    },
    {
      title: "Đã đọc",
      dataIndex: "seen",
      key: "seen",
      render: (isRead: any) => isRead && <FontFa name="faCheckCircle" color="#3DE91A" />,
      align: "center" as const,
    },
    {
      title: "Chưa đọc",
      dataIndex: "seen",
      key: "seen",
      render: (isRead: any) => !isRead && <FontFa name="faTimesCircle" color="#EE4E25" />,
      align: "center" as const,
    },
  ];

  const handleDateChange = (value: Moment | null) => {
    if (!value) {
      searchParams.delete("start");
      searchParams.delete("end");
      pushSearchParams(searchParams);
      return;
    }
    const month = value.clone();
    const firstDay = moment(month).startOf("month");
    const lastDay = moment(month).endOf("month");
    searchParams.set("start", firstDay?.startOf("day")?.toISOString() || "");
    searchParams.set("end", lastDay?.endOf("day")?.toISOString() || "");
    pushSearchParams(searchParams);
  };

  return (
    <>
      <div className="modal-title">
        <div className="modal-left">
          <div>
            <h5 style={{ color: "#00a9c4" }}>Bảng thống kê danh sách tài liệu ban hành cho người dùng</h5>
          </div>
          <div className="d-flex column">
            <p className="mx-2">
              <span style={{ fontWeight: "bold" }}>Tài liệu ban hành đến: </span>
              {name}
            </p>
          </div>
          <div>
            <p className="mx-2">Tổng cộng: {countTotalDocument}</p>
            <p className="mx-2">
              Đã đọc: <span className="text-success">{countReadDocument}</span>
            </p>
            <p className="mx-2">
              Chưa đọc: <span className="text-danger">{countUnReadDocument}</span>
            </p>
          </div>
        </div>
        <div className="modal-right">
          <div className="py-2 modal-date-picker">
            <span className="modal-date-text">Thời gian ban hành/triển khai</span>
            <DatePicker placeholder="Vui lòng chọn ngày" style={{ width: "66%" }} onChange={handleDateChange} />
          </div>
          <Button type="primary" onClick={handleExport}>
            Xuất excel
          </Button>
        </div>
      </div>

      <div className="p-0 modal-body">
        <Table
          rowKey="id"
          columns={columns}
          loading={isLoading}
          showHeader={true}
          dataSource={docsOfUserData}
          pagination={{
            pageSize: 10,
            total: docsOfUserData?.length || 0,
            showTotal: (total) => `Tổng cộng: ${total}`,
            position: ["bottomRight"],
          }}
        />
      </div>
    </>
  );
};
